import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import 'ant-design-vue/dist/antd.css';
import Antd from 'ant-design-vue';
import vuex from './store/index'
import iupigin from './styles/index.scss'




import { createFromIconfontCN } from '@ant-design/icons-vue';

const MyIcon = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2033419_extitw862n.js', // 在 iconfont.cn 上生成
});



const app = createApp(App);
app.use(router);
app.use(Antd);
app.use(vuex);

app.component('my-icon', MyIcon)
app.config.silent = true
//自定义全局组件部分

const requireComponent = require.context('@/components', true, /\.vue$/);
(component => {
    // 遍历获取组件对象，注册组件
    component.keys().map(fileName => {
        const com = requireComponent(fileName)['default'];
        if(com.hasOwnProperty("componentname")) {
            const componentname = "df-"+com.componentname;
            app.component(componentname, com);
        }
    });
})(requireComponent);

app.mount('#app');
